"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefixEnvironmentWithoutQA = void 0;
const prefix_environment_1 = require("../prefix-environment/prefix-environment");
/**
 * Get the "stg" prefix of the environment in the given url or current if not passed.
 * @public
 *
 * @param host - A domain url
 *
 * @returns "stg." if url has stg, qa, local or localhost in its parts otherwise empty because there is no environment
 *
 * @example
 * ```ts
 * const stgPrefix1 = prefixEnvironmentWithoutQA("https://enroll.stg.pivothealth.com"); // Output: "stg."
 * const stgPrefix2 = prefixEnvironmentWithoutQA("https://enroll.qa.pivothealth.com"); // Output: "stg."
 * ```
 */
function prefixEnvironmentWithoutQA(host = '') {
    return (0, prefix_environment_1.prefixEnvironment)(host).replace('qa.', 'stg.');
}
exports.prefixEnvironmentWithoutQA = prefixEnvironmentWithoutQA;
//# sourceMappingURL=prefix-environment-without-qa.js.map